





























































import { Component, Vue } from 'vue-property-decorator'
import ExperimentWrapper from './components/ExperimentWrapper.vue'

@Component({
  components: {
    ExperimentWrapper
  }
})
export default class App extends Vue {}
